export default function actionTrigger(type, data) {
  return { type, data };
}



// WEBPACK FOOTER //
// ./app/actions/index.js